module.exports = __webpack_public_path__ + "img/cocational_fileList2.ca759b50.jpg";